import type { TranslatesReplacements } from '@powerplay/core-minigames'

/**
 * Vymeny textov pre preklady - prekonkretnu disciplinu
 */
export const translatesReplacements: TranslatesReplacements[] = [

  {
    text: 'tutorialTask5-3',
    replace: [
      {
        original: '[number]',
        new: '10'
      }
    ]
  },
  {
    text: 'tutorialText5-2',
    replace: [
      {
        original: '[start]',
        new: 'START'
      }
    ]
  },

]
